




import { Component, Vue, Prop } from 'vue-property-decorator';
import { Enquiry } from '@/models/enquiry';

@Component
export default class EnquiryStatusLabel extends Vue {
    @Prop({ required: true }) public enquiry: Enquiry;

    public get className(): { [key: string]: boolean } {
        switch (this.enquiry.status) {
        case 0:
            return { 'label-info': true };
        case 1:
            return { 'label-warning': true };
        case 2:
            return { 'label-success': true };
        case 3:
            return { 'label-danger': true };
        case 4:
            return { 'label-primary': true };
        case 5:
            return { 'label-success': true };
        case 6:
            return { 'label-success': true };
        default:
            return { 'label-default': true };
        }
    }
    public get description(): string {
        switch (this.enquiry.status) {
        case 0:
            return `Awaiting quote`;
        case 1:
            return `Quote sent`;
        case 2:
            return `Quote approved`;
        case 3:
            return `Quote rejected`;
        case 4:
            return `Order placed`;
        case 5:
            return `Order received`;
        case 6:
            return `Order delivered`;
        default:
            return `Unknown`;
        }
    }
}
